var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreateInbound = function SvgCreateInbound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n        opacity: .25;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 5.83,
    y1: 102.04,
    x2: 194.17,
    y2: 102.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -680.1,
    y1: -4899.13,
    x2: -835.35,
    y2: -5013.72,
    gradientTransform: "translate(3059.59 -3955.01) rotate(-135)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096",
    stopOpacity: 0.25
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M172.57,146.02h0c-.83-.83-2.08-1.08-3.16-.63-1.09.45-1.79,1.5-1.79,2.68v5.19h-103.55l-7.24-7.25c-.83-.83-2.08-1.08-3.16-.63-1.09.45-1.79,1.5-1.79,2.68v4.96c-8.59-1.4-14.94-8.77-14.94-17.6,0-9.83,8-17.83,17.84-17.83h46.3l7.24,7.24c.82.82,2.1,1.08,3.16.63,1.09-.45,1.79-1.5,1.79-2.68v-5.19h31.95c26.99,0,48.94-21.95,48.94-48.93s-21.95-48.94-48.94-48.94h-12.91l-7.24-7.24c-.83-.83-2.08-1.08-3.16-.63-1.09.45-1.79,1.5-1.79,2.68v5.19H8.73c-1.6,0-2.9,1.3-2.9,2.9v25.3c0,1.6,1.3,2.9,2.9,2.9h111.38v5.19c0,1.18.7,2.23,1.79,2.68,1.06.44,2.35.18,3.16-.63l7.24-7.24h12.92c9.84,0,17.84,8,17.84,17.83s-8,17.83-17.84,17.83h-31.95v-5.2c0-1.18-.7-2.23-1.79-2.68-1.09-.45-2.33-.2-3.16.63l-7.25,7.25h-46.3c-26.99,0-48.94,21.95-48.94,48.94s20.14,47.34,46.04,48.85v5.28c0,1.18.7,2.23,1.79,2.68,1.07.45,2.35.19,3.17-.63l7.24-7.24h103.55v5.19c0,1.18.7,2.23,1.79,2.68.35.15.73.22,1.11.22.78,0,1.5-.3,2.05-.85l20.75-20.74c.55-.55.85-1.28.85-2.05s-.3-1.5-.85-2.05l-20.75-20.75ZM170.52,178.56h-100.64l7.69-7.69c.55-.55.85-1.28.85-2.05s-.3-1.5-.85-2.05l-7.69-7.69h100.64c1.6,0,2.91-1.3,2.91-2.9v-1.08l13.74,13.74-13.74,13.73v-1.08c0-1.6-1.3-2.9-2.91-2.9ZM54.77,178.56c-23.78,0-43.13-19.35-43.13-43.13s19.35-43.13,43.13-43.13h40.49l-7.69,7.69c-1.13,1.13-1.13,2.97,0,4.11l7.69,7.69h-40.49c-13.04,0-23.65,10.61-23.65,23.64s10.61,23.64,23.65,23.64c1.6,0,2.9-1.3,2.9-2.9v-1.08l13.73,13.74-13.73,13.73v-1.08c0-1.6-1.3-2.9-2.9-2.9ZM110.37,92.3h34.86c13.04,0,23.65-10.61,23.65-23.64s-10.61-23.64-23.65-23.64h-7.11l7.69-7.69c.55-.55.85-1.28.85-2.05s-.3-1.51-.85-2.05l-7.69-7.69h7.11c23.78,0,43.13,19.35,43.13,43.13s-19.35,43.13-43.13,43.13h-34.86c-1.6,0-2.9,1.3-2.9,2.9v1.08l-13.73-13.73,13.73-13.73v1.09c0,1.6,1.3,2.9,2.9,2.9ZM123.02,45.02H11.64v-19.49h111.38c1.6,0,2.9-1.3,2.9-2.9v-1.09l13.73,13.73-13.73,13.73v-1.09c0-1.6-1.3-2.9-2.9-2.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.12,1.49l94.93,94.93c1.98,1.98,1.98,5.18,0,7.16l-94.93,94.93c-3.19,3.19-8.64.93-8.64-3.58V5.07c0-4.51,5.45-6.77,8.64-3.58Z"
  })));
};
export default SvgCreateInbound;